module.exports = __webpack_public_path__ + "media/images/shark/SharkCafeMap-p-1600-e684b839daf4d6712cee0313df972484.jpg";